'use strict';
exports.default = exports;

// const {TransactionType, BillingActions} = require('../status');
// const gql = require('graphql-tag').gql;
const BaseEntity = require('./BaseEntity.js').BaseEntity;
// const moment = require('moment');
const _ = require('lodash');
const {CompanyUserEntity} = require('./CompanyUserEntity');
const StringUtils = require('../StringUtils');

class UserEntity extends BaseEntity {
  id = '';
  active = true;
  name = '';
  nameLowerCase = '';
  email = '';
  gender = '';
  hasAuth = false;
  isDeprecated = false;
  favoriteProcedures = [];
  favoriteSurgeons = [];
  types = [];
  companyAndFiliaisIds = [];
  companyAndFiliaisAccessIds = [];
  document = '';
  birthDateIso = '';
  userPartial = false; // Usuário parcial, não pode ter acesso ao sistema

  /**
   * @type {CompanyUserEntity|object|undefined}
   */
  _companyUser = null;
  /**
   * @type {CompanyUserEntity|object|undefined}
   */
  _companyUserMatriz = null;
  /**
   * @type {Object.<string, CompanyUserEntity>|object}
   */
  companiesUser = {};
  meta = {};
  cnes = '';
  phone = '';

  // TMP para bloquear edições no company_users
  updateOnlyByMed = false;

  // TODO ainda não utilizado
  createdAtCompanyId = '';  // Empresa em que o usuário foi criado inicialmente


  isVolanUser = false;
  isParallelUniverse = false;
  userBoardsResumes = [];

  _boardInfo = '';
  _companiesActives = []; // usado no currentUser do auth
  _companyId = null;
  _matrizId = null;


  institutions = null;
  integrations = null;

  // Não sei se é necessário
  workplace = null;

  // Temporario
  sigla = '';
  crm = '';
  crmState = '';
  cpf = '';
  nit = '';
  profileImgUrl = '';
  specialtyId = '';


  // Gambiarra para o ios funcionar
  companyIds = [];
  version = 0;
  address = {};

  /**
   *
   * @param {UserEntity|object?} obj
   * @param {string?} currentCompanyId
   */
  constructor(obj, currentCompanyId = undefined, currentMatrizId = undefined) {
    super(obj);
    this.setFcm(obj);
    if (currentCompanyId) {
      if (currentMatrizId) {
        if (this.companiesUser?.[currentMatrizId]) {
          this._companyUser = new CompanyUserEntity(this.companiesUser[currentMatrizId]);
          this._matrizId = currentMatrizId;
          this._companyId = currentCompanyId;
        }
      }
      else {
        if (this.companiesUser?.[currentCompanyId]) {
          this._companyUser = new CompanyUserEntity(this.companiesUser[currentCompanyId]);
          this._companyId = currentCompanyId;
        }
      }
    }
  }

  fixComputed() {
    if (this.document) {
      this.cpf = this.document;
    }
    this.types = [];
    this.userBoardsResumes = [];
    this.companyAndFiliaisAccessIds = [];
    for (const cId in this.companiesUser || {}) {
      const compUser = this.companiesUser[cId];
      if (!compUser) {
        delete this.companiesUser[cId];
        continue;
      }
      if (compUser.type) {
        this.types = _.union(this.types, [compUser.type]);
      }
      if (this.hasAuth && compUser.active) {
        if (compUser.hasAccess) {
          this.companyAndFiliaisAccessIds = _.union(this.companyAndFiliaisAccessIds, [cId]);
        }
        if (compUser.hasAccessFiliais) {
          this.companyAndFiliaisAccessIds = _.union(this.companyAndFiliaisAccessIds, compUser.filiaisIds);
        }
      }

      this.companyAndFiliaisIds = _.union(this.companyAndFiliaisIds, [cId], compUser.filiaisIds);
      for (const ub of compUser.userBoardInfos ||[]) {
        if (ub.boardNumber) {
          this.userBoardsResumes = _.union(this.userBoardsResumes, [ub.boardNumber+ub.region]);
          this.crm = ub.boardNumber;
          this.crmState = ub.region;
        }
      }
      if (compUser.acronym && !this.sigla) {
        this.sigla = compUser.acronym;
      }
    }

    // Gambiarra para o ios funcionar
    this.companyIds = this.companyAndFiliaisIds;
    this.nameLowerCase = StringUtils.deburr(this.name);
  }

  example() {
    this.setFcm({
    });
    return this;
  }

  getFullMutation(key = 'id') {
    if (!this.batchesIds) {
      this.batchesIds = [];
    }
    return super.getFullMutation(key);
  }


  getCompanyUser(companyId) {
    return getCompanyUser(this, companyId);
  }

}


/**
 *
 * @param user
 * @param companyId
 * @returns {CompanyUserEntity|null}
 */
function getCompanyUser(user, companyId) {
  if (companyId) {
    return user.companiesUser?.[companyId] || null;
    // if (matrizId) {
    //   return user.companiesUser?.[matrizId] || null;
    // }
    // else {
    //   return user.companiesUser?.[companyId] || null;
    // }
  }
}


const defaultUser = {
  active: false,
  types: [],
  companyAndFiliaisIds: [],
  companiesUser: {},
};


function getUserAuth(d, companyId, matrizId) {
  if (!d) {
    return null;
  }
  const user = _.cloneDeep(d);

  user._companyUser = null;
  user._companiesActives = [];
  if (companyId) {
    if (matrizId) {
      user._companyUser = user?.companiesUser?.[companyId] || null;
      user._companyUserMatriz = user?.companiesUser?.[matrizId] || null;
      user._companyId = companyId;
      user.matrizId = companyId;
    }
    else {
      user._companyUser = user?.companiesUser?.[companyId] || null;
      user._companyId = companyId;
    }
  }
  return user;
}



UserEntity._defaults = new UserEntity();


// const UserFragment = gql`
//   fragment UserFragment on User {
//     active
//     id
//   }
// `;

exports.UserEntity = UserEntity;
exports.getCompanyUser = getCompanyUser;
exports.getUserAuth = getUserAuth;
exports['defaultUser'] = defaultUser;
// exports.UserFragment = UserFragment;




